import request from '@/utils/request'
// 合作协定方列表
export function getAgreementList(data) {
  return request({
    url: '/health-recommend/prescription/main/doctorPrescriptionList',
    method: 'get',
    params: data
  })
}

// 合作协定方详情
export function getAgreementDetail(data) {
  return request({
    url: '/health-recommend/prescription/main/detail-info',
    method: 'post',
    data
  })
}

// 零售价变更记录
export function getPriceChange(data) {
  return request({
    url: '/health-assistant/air/pharmacy/prescription/pricePage',
    method: 'post',
    data
  })
}

// 获取协定方基本信息
export function getAgreementBaseInfoApi(data) {
  return request({
    url: '/health-recommend/prescription/main/doctorPrescriptionDetail',
    method: 'get',
    params: data
  })
}
